/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { ActivityPage } from '@/pages/Activity/ActivityPage';

export function ActivityRoute() {
  return <ActivityPage />;
}
